// Staff chat MVP (SR-14) sits behind the per-browser switch `?x=staff-chat` (encounter-flags.ts): ON by default on the dev
// hosts only (Andrew, 3 Nov), off elsewhere; `?x=-staff-chat` brings back no chat. OFF: no Team dock, no Team home card, no hub connection, and /messages/:threadId opens nothing.
//
// Patient threads ("Message a colleague" on the chart and encounter headers, the patient card in a thread) wait for
// Samer's call (patient-data access and audit): their own switch `?x=staff-chat-patient`, off by default, and only with
// staff chat on. The backend calls stay; only the UI is held back.
import type { PractitionerNavItem } from '@scripsteam/scrips-signal-ds';
import { isEncounterFlagOn } from '@/shared/lib/encounter-flags';

export const isStaffChatOn = (): boolean => isEncounterFlagOn('staffChat');
/** `?x=team-in-rail`: the chat opens from a Team tile in the left menu; no collapsed bar at the bottom of the screen. */
export const isTeamInRailOn = (): boolean => isStaffChatOn() && isEncounterFlagOn('teamInRail');

/** The Team tile's id: it opens the chat panel, it is not a page. */
export const TEAM_NAV_ID = 'team';
export const TEAM_NAV_ITEM: PractitionerNavItem = { id: TEAM_NAV_ID, label: 'Team', icon: 'chat' };

/** The rail's tiles plus Team, last (under Analytics when that is on), when `teamInRail` is on. */
export const withTeam = (base: PractitionerNavItem[], on: boolean): PractitionerNavItem[] => (on ? [...base, TEAM_NAV_ITEM] : base);
export const isStaffChatPatientOn = (): boolean => isStaffChatOn() && isEncounterFlagOn('staffChatPatient');
